<template>
  <div class="container">
    <h2 style="margin-bottom: 35px">
      <svg
        width="45px"
        height="39px"
        viewBox="0 0 45 39"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Indmeldelsesflow"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="D/600-Tak"
            transform="translate(-233.000000, -363.000000)"
            fill="#C0CE2E"
          >
            <path
              d="M276.842112,363 C263.154023,371.393332 253.222276,381.982846 248.753805,387.293912 L237.827253,378.732061 L233,382.624305 L251.884996,401.830031 C255.135782,393.507369 265.431747,377.231698 278,365.674559 L276.842112,363 Z"
              id="verify"
            ></path>
          </g>
        </g>
      </svg>
      <div
        v-if="this.$store.state.texts.WelcomeTitle"
        v-html="this.$store.state.texts.WelcomeTitle"
        style="display: inline-block"
      ></div>
      <br />
    </h2>
    <div
      v-if="this.$store.state.texts.WelcomeDescription"
      v-html="this.$store.state.texts.WelcomeDescription"
    ></div>
  </div>
</template>

<script>
  export default {
    props: {
      page: {
        type: Object,
        description: '',
        title: '',
      },
    },
    beforeCreate() {
      this.$store.spinner = true;
    },
    mounted() {
      const payload = {
        endpoint: `${this.$store.state.pageData.EndpointEmploymentBoundTexts}/${this.$route.params.employment}.json`,
      };
      this.$store.dispatch('getEmploymentBoundTexts', payload);
      this.$store.spinner = false;

      // Push to GA with window.dataLayer.
      window.dataLayer.push({
        event: 'indmeldelse',
        indmeldelsesType: this.$route.params.employment,
      });
    },
  };
</script>

<style lang="scss" scoped>
  h2 {
    margin-bottom: 40px;

    svg {
      margin-right: 10px;
      vertical-align: bottom;
    }
  }
</style>

